import { createAction } from 'typesafe-actions'

export const toggleSidebarExpand = createAction('CMD / sidebar / toggle expand')()

export const setSidebarExpandState = createAction('DOC / sidebar / set expand state')<boolean>()
